module.exports = __webpack_public_path__ + "static/media/numeric-code-method.e7ad6399.svg";